import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { PATH } from '@/utils/constant';

const HeaderBody = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: var(--main1-bg-color);
  box-sizing: border-box;
`;

const StyledTitle = styled.h3`
  cursor: pointer;
`;

const Header = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(PATH.intro);
  };

  return (
    <HeaderBody>
      <StyledTitle onClick={handleClick}>Server Developer 이혜원</StyledTitle>
    </HeaderBody>
  );
};

export default Header;
